import * as iconPaths from '@mobi/component-library/Common/Icon/iconPaths'

interface IconTypes {
  Races: 'races'
  Trots: 'trot'
  Dogs: 'dog'
}

const iconTypes: IconTypes = {
  Races: 'races',
  Trots: 'trot',
  Dogs: 'dog',
}

export function getIconTypeFromMeetingCode(
  meetingCode: string | undefined
): keyof typeof iconPaths | undefined {
  if (meetingCode) {
    const loweredMeetingCode = meetingCode.toLowerCase()

    switch (loweredMeetingCode) {
      case 'r':
      case 'race':
      case 'races':
      case 'racing':
        return iconTypes.Races
      case 't':
      case 'trot':
      case 'trots':
        return iconTypes.Trots
      case 'd':
      case 'dog':
      case 'dogs':
      case 'greyhounds':
        return iconTypes.Dogs
      default:
        return undefined
    }
  }
  return undefined
}
